import { queryOptions } from "@tanstack/react-query";

import { getHierarchy, getUserRole, HierarchicalDto } from "../usersApi";

const getHierarchyQueryOption = () =>
    queryOptions<HierarchicalDto>({
        queryKey: ["hierarchy"],
        queryFn: () => getHierarchy()
    });

const getUserRoleQueryOption = (crmId: number) =>
    queryOptions<string>({
        queryKey: ["userRole", crmId],
        queryFn: () => getUserRole(crmId),
        enabled: Boolean(crmId)
    });

export { getHierarchyQueryOption, getUserRoleQueryOption };
